<template>
    <div class="box">
    <div class="animate-ball" :style="ballStyle" v-show="showBall"></div>

  <studentTitleCard  isChange @change="studentChange" style="height: 170px;">
  <template slot="btn">
    <div class="topbox">
     <van-row gutter="10">
        <van-col span="10" class="topbox_l">
        <!-- <van-button round  type="info" style="height: 28px;line-height: 28px;width: 80px;font-size: 12px;" @click="goShop">快速兑换</van-button> -->
     </van-col>
      <van-col span="14" class="topbox_r"  >
        <img width="40" height="40" style="margin-right: 8px;" src="@/assets/image/金币.png" alt="">
        <div style="font-size: 40px;font-weight: 500;margin-right: 8px;">{{ 6850 }}</div>
        <!-- <div style="font-size: 18px;font-weight: 500;"> > </div> -->
     </van-col>
    
   </van-row>
    </div>
  </template>
</studentTitleCard>
<van-sticky>
  <van-tabs v-model="active" class="activebox">
        <van-tab v-for="(item,index) in tabList" :key="index" :title="item.name" :name='item.id'>
        </van-tab>
   </van-tabs>
</van-sticky>
  
        <div class="ul">
            <div class="comm_li" v-for="(item,index) in commDataList" :title="item.name" :name='item.id'>
              <div class="comm_li_img"><img width="100%" height="100%" :src="item.img" style="border-radius: 8px;" alt=""></div>
              <div class="comm_li_name">{{ item.name }}</div>
              <div class="comm_li_bottom">
                <div class="comm_li_bottom_pic">
                  <div>{{ item.int }}积分</div>
                  <div style="font-size: 15px;">+{{  item.price}}元</div>
                </div>
                <div class="comm_li_bottom_shopCart" @click="addCart($event)">
                  <van-icon name="shopping-cart" />
                </div>
              </div>
            </div>
        </div>
      
        <div class="bottombox" v-show="showBottombox">
            <van-goods-action>
            <van-goods-action-icon icon="chat-o" text="客服" />
            <van-goods-action-icon icon="cart-o" ref="cartIcon" text="购物车" :badge="cartNum" />
            <van-goods-action-button color="#be99ff"  type="warning" text="加入购物车" />
            <van-goods-action-button color="#7232dd" type="danger" text="立即购买" @click="goBuy"/>
            </van-goods-action>
        </div>
          <!-- 在模板中添加动画元素 -->
  </div>
  
  </template>
  
  <script>
  import CustomButton from "@/components/CustomButton.vue";
  import { checkOrder,getHomeworkInfoList} from "@/api/homework.js";
  import studentTitleCard from "@/components/studentTitleCardV2.vue";
  
  export default {
  data () {
      return {
        showBall: false,
        showBottombox: false,
        
      ballStyle: {},
      drop: {
        startX: 0,
        startY: 0,
        endX: 0,
        endY: 0
      },
        cartNum:2,
        tabList:[
            {name:'精选',id:1},
            {name:'<1000积分',id:2},
            {name:'1000-3000积分',id:3},
            {name:'3000-5000积分',id:4},
            {name:'5000-8000积分',id:5},
            {name:'8000-1万积分',id:6},
            {name:'>1万积分',id:7},
        ],
        commDataList:[
        {name:'你想活出怎样的人生',id:1,int:'5850',price:'13.8',img:require("./img/1.png"),msg:''},
        {name:'大中华寻宝系列',id:2,int:'4150',price:'13.8',img:require("./img/2.png"),msg:''},
        {name:'吉林寻宝记',id:3,int:'6230',price:'13.8',img:require("./img/3.png"),msg:''},
        {name:'新华书店科学漫画',id:4,int:'3850',price:'13.8',img:require("./img/4.png"),msg:''},
        {name:'三国演义绘本',id:5,int:'7950',price:'13.8',img:require("./img/5.png"),msg:''},
          {name:'屁屁侦探绘本',id:6,int:'4250',price:'34.8',img:require("./img/6.png"),msg:''},
          {name:'店长推荐 神奇的逻辑思维',id:16,int:'4150',price:'23.8',img:require("./img/7.png"),msg:''},
          {name:'挑战你的大脑',id:11,int:'1850',price:'13.8',img:require("./img/8.png"),msg:''},
          {name:'儿童大号仿真恐龙模型玩具动物霸王龙套装益智早教男孩生日礼物',id:11,int:'3580',price:'3.8',img:require("./img/1.jpeg"),msg:''},
          {name:'儿童平衡车无脚踏18个月-4岁宝宝玩具学步溜溜车滑行车滑步车',id:12,int:'8888',price:'123.8',img:require("./img/2.jpeg"),msg:''},
          {name:'2023新高考版PASS高中学业水平考试真题护眼纸大行空绿卡图书',id:31,int:'4850',price:'1.8',img:require("./img/3.jpeg"),msg:''},
          {name:'小学英语晨读美文小学英语经典晨读 21天小学生英语教辅书练习册',id:41,int:'4850',price:'33.8',img:require("./img/4.jpeg"),msg:''},
          {name:'正版学霸课堂笔记初中历史初一初二初三通用版配套教材全解教辅书',id:61,int:'4850',price:'37.8',img:require("./img/6.jpeg"),msg:''},

     
        ],
          childInfoList:[],
          studentInfo:{},
          active:1,
          dataList:[],
          weekFil:['','周一','周二','周三','周四','周五','周六','周日'],
          onStudentInfo:{}
      }
  },
  components: {
    CustomButton ,
    studentTitleCard
  },
  mounted () {
      this.init()
  },
  methods:{
    goBuy(){
  // 没有准考证
  this.$dialog
                  .alert({
                  message: '正在维护中，敬请期待！！',
                  showCancelButton: false
                  }).then(() => {
                  })
    },
    addCart(event) {
      
      if (!this.showBottombox) {
        this.showBottombox = true
        return
      }

      // 获取点击位置
      const clickPosition = this.getClickPosition(event)
      // 获取购物车位置
      
      const cartPosition = this.getCartPosition()
      // 设置抛物线起点和终点
      this.drop.startX = clickPosition.x
      this.drop.startY = clickPosition.y
      this.drop.endX = cartPosition.x
      this.drop.endY = cartPosition.y

      // 显示动画小球
      this.showBall = true
      console.log(this.drop);
      
      // 开始动画
      this.$nextTick(() => {
        this.startAnimation(() => {
          this.showBall = false
          this.cartNum++
        })
      })
    },
    getClickPosition(event) {
      // 获取点击位置坐标
      const rect = event.target.getBoundingClientRect()
      return {
        x: rect.left + rect.width/2,
        y: rect.top + rect.height/2
      }
    },
    getCartPosition() {
        // 方法1：优先使用ref获取元素
        if (this.$refs.cartIcon && this.$refs.cartIcon.$el) {
        const cartEl = this.$refs.cartIcon.$el
        const rect = cartEl.getBoundingClientRect()
        return {
          x: rect.left + rect.width/2 - window.pageXOffset, // 考虑横向滚动
          y: rect.top + rect.height/2 - window.pageYOffset  // 考虑纵向滚动
        }
      }

      // 方法2：备用方案通过class选择器获取
      const cartEl = document.querySelector('.cart-icon')
      if (cartEl) {
        const rect = cartEl.getBoundingClientRect()
        return {
          x: rect.left + rect.width/2,
          y: rect.top + rect.height/2
        }
      }

      // 最终备用方案：固定位置（需要根据实际情况调整）
      return {
        x: window.innerWidth - 40, // 右侧位置
        y: window.innerHeight - 40 // 底部位置
      }
    },
    startAnimation(callback) {
      // 改进后的抛物线公式
      const startTime = Date.now()
      const duration = 800
      const deltaX = this.drop.endX - this.drop.startX
      const deltaY = this.drop.endY - this.drop.startY
      const gravity = 0.5 // 重力系数

      const animate = () => {
        const currentTime = Date.now() - startTime
        const progress = Math.min(currentTime / duration, 1)
        
        // 水平匀速运动
        const x = this.drop.startX + deltaX * progress
        
        // 垂直抛物线运动（添加重力因子）
        const y = this.drop.startY + 
          deltaY * progress + 
          gravity * 300 * Math.sin(progress * Math.PI)

        // 动态缩放（0.8~1.2范围）
        const scale = 0.8 + 0.4 * Math.sin(progress * Math.PI)

        this.ballStyle = {
          transform: `translate(${x}px, ${y}px) scale(${scale})`,
          transition: 'none'
        }

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          callback?.()
        }
      }
      animate()
    },
    // addCart(){
    //   this.cartNum++
    // },
    studentChange(val){
    this.onStudentInfo =val
    this.getHomeworkInfoList()
  //   this.checkOrder()
    },
    onReport(item){
        let data = JSON.stringify({...this.onStudentInfo,
             termName: item.name,
        termCode:item.code,
        })
          this.$router.push({path:'fitnessReport',query:{data:data}})
    },
      onAddAppoint(item){
         let data = {
              snCode:this.onStudentInfo.snCode,
              schoolCode:this.onStudentInfo.schoolCode,
              homeId:item.homeId
            }
          this.$router.push({path:'homeworkInfo',query:data})
      },
       activeTabs(){
           this.getHomeworkInfoList()
           this.checkOrder()
      },
      init(){
          //   getChildInfoList({status:'1'}).then(res=>{
          // console.log(res);
          // this.childInfoList = res.data.data||[]
          // })
        
      },
      checkOrder(){
          checkOrder({
              snCode:this.onStudentInfo.snCode,
              schoolCode:this.onStudentInfo.schoolCode,
            }).then(res=>{
              // 检查是否有准考证
              console.log(res);
              if (!+res.data.body) {
                  // 没有准考证
                  this.$dialog
                  .alert({
                  message: '请先申请电子准考证！！',
                  showCancelButton: false
                  }).then(() => {
                      this.$router.push({path:'admissionTicket'})
                  })
          
              }   
              // res.body
            })
      },
      getHomeworkInfoList(){
          getHomeworkInfoList({
              snCode:this.onStudentInfo.snCode,
              schoolCode:this.onStudentInfo.schoolCode,
            }).then(res=>{
              console.log(res);
           
              this.dataList = res.data.data||[]
            })
      },
      OnaddFaceIn(){
          if (!this.studentInfo.faceData||this.studentInfo.faceData=='') {
              this.$notify({ type: "danger", message: '请拍摄证件照！' });
              return
          }
          this.$dialog
          .alert({
            message: '是否确认生成准考证?',
            showCancelButton: true
          })
          .then(() => {
              insertIntoFaceData(this.studentInfo).then(Res=>{
              this.$notify({ type: "success", message: '生成成功！' });
              this.$router.back(-1)
              })
          })
          .catch(() => {
            // on cancel
          })
      },
      goShop(){
          this.$router.push({path:'/integralShop/shop'})
      }
  }
  }
  </script>
  
  <style lang="less" scoped>
  .box{
      height: 100%;
      font-size: 3vw;
      // background-color: #f8f7f7;
  //     background-image: url('../../assets/background/homeBG.png')!important;
	// background-repeat: no-repeat;
	// background-size: 100% 100%;
  }
  .animate-ball {
  position: fixed;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #7232dd;
  z-index: 9999;
  pointer-events: none;
  transition: all 0.5s cubic-bezier(0.5, -0.5, 1, 1);
}


  .activebox{
    height: 5%;
    background-color: pink;

  }
  .ul{
    padding: 10px 0px;
    // overflow: scroll;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 50px;

    .comm_li{
    //  background-color: skyblue;
    background-color: #fff;
     width: calc(50% - 20px);
    //  width: 50%;
     height: 270px;
     border-radius: 10px;
     margin: 5px;
     padding: 5px;
     .comm_li_img{
      height: 180px;
      border-radius: 8px;
     }
     .comm_li_name{
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      font-weight: 600;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap; /* 不换行 */
     }
     .comm_li_bottom{
      display: flex;
      // justify-content: space-between;
      justify-content: space-between;
      align-items: center;
      .comm_li_bottom_pic{
        color: #eb4a4a;
        font-size: 20px;
        margin: 10px 0;
      }
      .comm_li_bottom_shopCart{
        border-radius: 50%;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 18px;
        background-color: #dad3d3;
        margin-right: 8px;
      }
     }
    }
  }
  .bottombox{
    background-color: pink;
    
     ::v-deep .van-goods-action{
       position: fixed;
       bottom: 60px;
       left: 0;
     }
  }
  .text_l{
      text-align: left;
      text-overflow:ellipsis;
      overflow:hidden;
      // white-space:nowrap;
      
  }
  .noActiceCard{
      position: relative;
   .ifActiveBox{
            position: absolute;
            right: 0px;
            top: 10px;
            transform: rotate(45deg);
          }
  }
  
  .project_title{
    font-size: 3.8vw;
    text-align: left;
    margin-bottom: 10px;
  }
  .project_ul{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .project_li{
      position: relative;
      width: 30%;
      height: 33px;
      margin-right: 3%;
      line-height: 33px;
      border-radius: 9px;
      font-size: 3.3vw;
      margin-bottom: 10px;
      background: rgba(0, 0, 0, 0.04);
     
  }
  .Week_li{
     position: relative;
      width: 12%;
      height: 30px;
      margin-right: 1%;
      line-height: 30px;
      border-radius: 9px;
      font-size: 3vw;
      margin-bottom: 10px;
  
      background: rgba(0, 0, 0, 0.04);
  }
   .isHaveScore{
        position: absolute;
        top: 0;
        right: 0;
        width: 20%;
      }
  
   .tag_span_green{
                  border: 1px solid rgb(61, 224, 61);
      border-radius: 8px;
                  color: #37cf18;
                  text-align: center;
                  width: 90%;
                  overflow: hidden;
              }
              .tag_span_grey{
                  border: 1px solid rgb(141, 135, 135);
      border-radius: 8px;
                  color: #6a6d69;
                  text-align: center;
                  width: 90%;
                  overflow: hidden;
              }
  }
  .project_baogao{
    text-align: center;
    font-size: 3.5vw;
    margin: 10px 0;
    color: #3c69e6;
  
  }
  .topbox{
    position: absolute;
    top: 25px;
    right: 0;

    height: 60px;
    line-height: 60px;
    // margin-bottom: 16px;
    color: #ffde73;
    .topbox_l{
        text-align: left;
    }
    .topbox_r{
        display: flex;
        align-items: center;
        align-content: center;
        text-align: right;
        justify-content: flex-end;
        // justify-content: right;
    }
  }
   .center{
          padding:12px;
          position: relative;
          background-color: #fff;
          border-radius: 10px;
          // border: 1px solid #ccc;
          margin: 8px;
          border: 1px solid rgba(0, 0, 0, 0.04);
          .center_name{
            font-size: 16px;
            font-weight: 500;
            margin-right: 8px;
            // margin: 5px 10px 15px 0px;
          }
          .center_value{
              color: #bbb;
          }
      
  
          .van_tag{
              // margin-left: 20px;
              text-align: center;
             
              /deep/ .van-grid-item__content{
                  padding: 0px;
                 border-radius: 8px;
  
              }
          }
  
          .center_text{
              text-align: left;
              font-size: 13px;
              margin-bottom: 50px;
              .center_text_title{
                  font-size: 25px;
                  font-weight: 700;
              }
          }
          .center_footer{
              text-align: left;
              .center_footer_title{
                  font-size: 20px;
                  font-weight: normal;
              }
              
              .center_footer_left{
  
              }
              .center_footer_right{
                  .center_footer_right_value{
                  font-size: 20px;
                  height: 50px;
                  line-height: 50px;
                  border: 1px solid #bbb;
                  margin-top: 10px;
                  text-align: center;
  
              }
              }
          }
      }
  </style>